import classNames from 'classnames'

// internal
import { useClusterForm } from '@aytm/app/stats/page/question-views/hm/components/controls/cluster-form/lib/hooks'
import { TIPS, CLUSTER_FORM_MODE } from '@aytm/app/stats/page/question-views/hm/components/controls/lib/constants'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// components
import { Button } from 'primereact/button'
import { TitleInput } from '@aytm/app/stats/page/question-views/hm/components/controls/cluster-form/TitleInput'

// styles
import style from '@aytm/app/stats/page/question-views/hm/components/controls/cluster-form/styles/ClusterForm.module.scss'

export const ClusterForm = ({
  clusters,
  visualPosition,
  onFetchCRUDKey,
  clusterFormMode,
  tip,
  currentCluster,
  onChangeModel,
  onUpdateData,
  changeClustersForm,
  getLassoData
}) => {
  const { title, setTitle, isLoading, error, isSaveDisabled, handleSave, handleDelete, handleCancel } = useClusterForm({
    clusters,
    currentCluster,
    visualPosition,
    onFetchCRUDKey,
    clusterFormMode,
    tip,
    onChangeModel,
    onUpdateData,
    getLassoData,
    changeClustersForm
  })

  const isAddMode = clusterFormMode === CLUSTER_FORM_MODE.ADD
  const isEditMode = clusterFormMode === CLUSTER_FORM_MODE.EDIT

  return (
    <div className={style.form}>
      <div className={style.formFields}>
        {currentCluster && (
          <ul className={style.tips}>
            {TIPS.map(tipItem => (
              <li key={tipItem.id} className={classNames(style.tipItem, { [style.active]: tip === tipItem.id })}>
                <div className={style.tipImage} dangerouslySetInnerHTML={{ __html: tipItem.svg }} />
                <p className={style.tipText}>{tipItem.text}</p>
              </li>
            ))}
          </ul>
        )}

        <div className={style.inputWrapper}>
          <TitleInput
            value={title}
            className={classNames(style.input, 'p-inputtext-rounded', { [style.editMode]: isEditMode })}
            placeholder="Custom cluster name"
            disabled={isLoading}
            onChange={setTitle}
          />
          {isAddMode && <div className={style.label}>Name your cluster</div>}
        </div>

        {isEditMode && (
          <span
            className={classNames(style.deleteButton, 'p-right')}
            aria-label="Delete cluster"
            title="Delete cluster"
            {...pressable(isLoading ? null : handleDelete)}
          >
            <i className="icon-aytmfd-trash" />
          </span>
        )}

        <div className={classNames(style.buttonsWrapper, 'p-right')}>
          <Button
            label="Save"
            className="p-button p-button-secondary p-button-rounded"
            onClick={handleSave}
            disabled={isLoading || isSaveDisabled}
          />
          <Button
            label="Cancel"
            className="p-button p-button-secondary p-button-rounded"
            onClick={() => handleCancel(true)}
            disabled={isLoading}
          />
        </div>
      </div>

      {error && <div className={style.formError}>{error}</div>}
    </div>
  )
}
